import { render, staticRenderFns } from "./Customer-settings.vue?vue&type=template&id=55955560&scoped=true&"
import script from "./Customer-settings.vue?vue&type=script&lang=js&"
export * from "./Customer-settings.vue?vue&type=script&lang=js&"
import style0 from "./Customer-settings.vue?vue&type=style&index=0&id=55955560&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55955560",
  null
  
)

export default component.exports